import React from 'react';
import Layout from '../../../components/Layout';
import MerchantTransactions from './MerchantTransactions';

const MerchantTransactionsPage = () => {
    return (
        <Layout>
            <MerchantTransactions />
        </Layout>
    );
};

export default MerchantTransactionsPage;
